export default "__VITE_ASSET__DLSyHZHt__"